import ContractService from '@/services/contract.service';
import Vue from 'vue';

const state = {
  // Keyed by `${leadEventId}_${venueId}`
  contractData: {},
};

const actions = {
  async fetchContracts({ commit, dispatch }, { leadEventId }) {
    try {
      const data = await ContractService.getContracts(leadEventId);
      commit('setContractData', { leadEventId, data });
      return data;
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      throw error;
    }
  },

  async createOrUpdateContract({ dispatch }, { leadEventId, payload }) {
    try {
      const result = await ContractService.createOrUpdateContract(leadEventId, payload);
      return result;
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      throw error;
    }
  },

  async uploadPdf({ dispatch }, { leadEventId, contractId, file }) {
    try {
      const result = await ContractService.uploadPdf(leadEventId, contractId, file);
      return result;
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      throw error;
    }
  },

  async signContract({ dispatch }, { leadEventId, contractId, payload }) {
    try {
      const result = await ContractService.signContract(leadEventId, contractId, payload);
      return result;
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      throw error;
    }
  },

  async sendToClient({ dispatch }, { leadEventId, contractId, venuePdfFile }) {
    try {
      const result = await ContractService.sendToClient(leadEventId, contractId, venuePdfFile);
      return result;
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      throw error;
    }
  },

  async deleteContract({ dispatch }, { leadEventId, contractId }) {
    try {
      const result = await ContractService.deleteContract(leadEventId, contractId);
      return result;
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      throw error;
    }
  },

  async getDownloadUrl({ dispatch }, { leadEventId, attachmentId }) {
    try {
      const result = await ContractService.getDownloadUrl(leadEventId, attachmentId);
      return result;
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      throw error;
    }
  },
};

const mutations = {
  setContractData(state, { leadEventId, data }) {
    Vue.set(state.contractData, leadEventId, data);
  },

  clearContractData(state, { leadEventId }) {
    Vue.delete(state.contractData, leadEventId);
  },
};

const getters = {
  // Returns per-venue data from the response data array.
  getContractData: (state) => (leadEventId, venueId) => {
    const allData = state.contractData[leadEventId];
    if (! allData) return null;
    const list = allData.data || [];
    return list.find(v => String(v.venue_id) === String(venueId)) || null;
  },

  getAllContractData: (state) => (leadEventId) => {
    return state.contractData[leadEventId] || null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
